import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useClientRemove } from "hook/clients/useClient";
import { FaRegFilePdf } from "react-icons/fa";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableRemove = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const isKyc = data?.kyc !== "unknown";

  const { loading, showConfirmDelete } = useClientRemove();
  const path = `/kyc/${data?.id}`;
  // -------------------------- STATE ---------------------------
  // const items = [
  //   // {
  //   //   key: "bailiff",
  //   //   icon: <IoDocumentTextOutline />,
  //   //   label: <a href={path}>Xem File</a>,
  //   // },
  //   {
  //     key: "kyc",
  //     icon: <FaRegFilePdf />,
  //     label: <span>Tải Hồ Sơ</span>,
  //   },
  //   {
  //     key: "remove",
  //     danger: true,
  //     icon: <DeleteOutlined />,
  //     label: <span onClick={() => showConfirmDelete(data)}>Xoá</span>,
  //   },
  // ];
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderKyc = () => {
    if (!isKyc) return null;
    return (
      <Tooltip title="Tải hồ sơ KYC">
        <Button
          href={path}
          shape="circle"
          type="text"
          icon={
            <span className="anticon">
              <FaRegFilePdf />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderRemoveClient = () => {
    // if (isKyc) return null;
    return (
      <Tooltip title="Xoá khách hàng">
        <Button
          onClick={() => showConfirmDelete(data)}
          loading={loading}
          shape="circle"
          type="text"
          danger
          icon={
            <span className="anticon">
              <DeleteOutlined />
            </span>
          }
        />
      </Tooltip>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <>
      {/* {renderKyc()} */}
      {renderRemoveClient()}
    </>
  );
};
export default TableRemove;
